// Lazyloading for images in CSS images are display: none if not in viewport
document.addEventListener('DOMContentLoaded', function () {
    let lazyloadImages;
    let lazyloadThrottleTimeout;

    function lazyloadPolyFill () {
        if (lazyloadThrottleTimeout) {
            clearTimeout(lazyloadThrottleTimeout);
        }

        lazyloadThrottleTimeout = setTimeout(function () {
            let scrollTop = window.pageYOffset;
            lazyloadImages.forEach(function (img) {
                if (img.offsetTop < (window.innerHeight + scrollTop)) {
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');
                }
            });
            if (lazyloadImages.length === 0) {
                document.removeEventListener('scroll', lazyloadPolyFill);
                window.removeEventListener('resize', lazyloadPolyFill);
                window.removeEventListener('orientationChange', lazyloadPolyFill);
            }
        }, 100);
    }

    if ('IntersectionObserver' in window) {
        lazyloadImages = document.querySelectorAll('.lazy');
        let imageObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let image = entry.target;
                    image.classList.remove('lazy');
                    imageObserver.unobserve(image);
                }
            });
        });

        lazyloadImages.forEach(function (image) {
            imageObserver.observe(image);
        });
    } else {
        lazyloadImages = document.querySelectorAll('.lazy');

        document.addEventListener('scroll', lazyloadPolyFill);
        window.addEventListener('resize', lazyloadPolyFill);
        window.addEventListener('orientationChange', lazyloadPolyFill);
    }
});
